export const en = {
    recommendation: 'Recommendations'
};
